import { __ } from '../../../locales'

const MinimalRatingFilter = ({ inputs, onInputsChange }) => {
    return (
        <div className={'input-component'}>
            <label>{__('inputs.minimal_rating.label')}:</label>
            <input
                type="number"
                className="form-control"
                value={inputs.rating}
                onInput={(ev) => onInputsChange('rating', ev.target.value)}
            />
        </div>
    );
};

export default MinimalRatingFilter;
